import { memo } from 'react';
import { ListItemProps, Typography } from '@mui/material';
import { ReferralInfo } from 'entities/referrer/model';
import { cratChainNativeToken, TokenFormat } from 'shared';

import { ListItemStyled } from '../styled';

type ReferralItemProps = {
  packageName: string;
} & Omit<ReferralInfo, 'TAP2MINEId'> &
  Pick<ListItemProps, 'sx'>;

export const ReferralItem = memo(({ referral, amount, packageName, sx }: ReferralItemProps) => {
  return (
    <ListItemStyled
      sx={{
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'start', sm: 'center' },
        justifyContent: 'space-between',

        ...sx,
      }}
    >
      <Typography variant="body2" className="secondary" width="100%" noWrap textOverflow="ellipsis">
        {referral}
      </Typography>
      <Typography variant="body2" className="primary" noWrap overflow="visible">
        +
        <TokenFormat
          amount={amount}
          decimals={cratChainNativeToken.decimals}
          maxDecimalDigits={6}
          trimEllipsis
          symbol="CRAT"
          variant="body2"
        />{' '}
        ({packageName})
      </Typography>
    </ListItemStyled>
  );
});
